import PageHeader from '@shared/components/PageHeader'
import SEO from '@shared/components/SEO'

const RATES = [
    { type: 'Institutional', one: 'Rs. 3,000', three: 'Rs. 6,000', five: 'Rs. 10,000' },
    { type: 'Individual', one: 'Rs. 1,000', three: 'Rs. 3,000', five: 'Rs. 5,000' }
]

const BANK: [string, string][] = [
    ['Name of Account Holder', 'Centre for Study of Politics and Governance'],
    ['Type of Account', 'Current Account'],
    ['Account Number', '6978481508'],
    ['Name of Bank', 'Indian Bank'],
    ['Branch Address', '33 Pratap Nagar, Mayur Vihar Phase-I, Patparganj, Delhi – 110092'],
    ['IFSC Code', 'IDIB000M102']
]

export default function Subscription() {
    return (
        <>
            <SEO
                title="Subscription"
                description="Subscribe to Indian Studies Review — institutional and individual subscription rates, payment details and subscriber form."
                path="/subscription"
            />
            <PageHeader
                eyebrow="The Journal"
                title="Subscription"
                lede="A formerly UGC-CARE listed and peer-reviewed journal, published bi-annually by the Centre for Study of Politics and Governance (CSPG)."
            />

            <section className="section">
                <div className="container-prose" style={{ maxWidth: '52rem' }}>
                    <div
                        className="flex flex-col sm:flex-row sm:items-center justify-between gap-5 px-6 py-6 mb-12"
                        style={{ background: 'var(--color-paper-100)', border: '1px solid var(--color-rule)', borderTop: '3px solid var(--color-gold-500)' }}
                    >
                        <div>
                            <div className="overline">Official Form</div>
                            <div className="font-display mt-2" style={{ fontSize: '1.25rem', color: 'var(--color-ink-700)', letterSpacing: '-0.012em' }}>
                                Indian Studies Review — Subscription Form
                            </div>
                            <p className="mt-1.5 text-[13.5px]" style={{ color: 'var(--color-ink-400)' }}>
                                Download, complete, and mail it with your remittance details (.docx).
                            </p>
                        </div>
                        <a
                            href="/SUBSCRIPTION-FORM.docx"
                            download
                            className="btn btn-primary text-xs uppercase tracking-[0.16em] px-6 py-3 shrink-0"
                        >
                            Download form ↓
                        </a>
                    </div>

                    <div className="wp-prose">
                        <h2>Journal Details</h2>
                        <p>
                            <strong>Title:</strong> Indian Studies Review
                            <br />
                            <strong>Publisher:</strong> Centre for Study of Politics and Governance (CSPG)
                            <br />
                            <strong>Frequency:</strong> Bi-Annual
                        </p>
                    </div>

                    <h2 className="font-display mt-12" style={{ fontSize: '1.6rem', color: 'var(--color-ink-700)' }}>
                        Subscription Rates
                    </h2>
                    <div className="mt-5 overflow-x-auto">
                        <table className="w-full text-left" style={{ borderCollapse: 'collapse', minWidth: '34rem' }}>
                            <thead>
                                <tr style={{ background: 'var(--color-paper-100)' }}>
                                    {['Subscription Type', 'One Year', 'Three Years', 'Five Years'].map((h) => (
                                        <th
                                            key={h}
                                            className="px-4 py-3 text-[11px] uppercase font-semibold"
                                            style={{
                                                letterSpacing: '0.12em',
                                                color: 'var(--color-ink-600)',
                                                border: '1px solid var(--color-rule)'
                                            }}
                                        >
                                            {h}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {RATES.map((r) => (
                                    <tr key={r.type}>
                                        <td
                                            className="px-4 py-3 font-semibold text-[14px]"
                                            style={{ color: 'var(--color-ink-700)', border: '1px solid var(--color-rule)' }}
                                        >
                                            {r.type}
                                        </td>
                                        {[r.one, r.three, r.five].map((v, i) => (
                                            <td
                                                key={i}
                                                className="px-4 py-3 text-[14px]"
                                                style={{ color: 'var(--color-ink-500)', border: '1px solid var(--color-rule)' }}
                                            >
                                                {v}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <h2 className="font-display mt-12" style={{ fontSize: '1.6rem', color: 'var(--color-ink-700)' }}>
                        Payment Details
                    </h2>
                    <p className="mt-1 text-[13px]" style={{ color: 'var(--color-ink-400)' }}>
                        NEFT / RTGS — Indian Rupees only
                    </p>
                    <div
                        className="mt-5"
                        style={{ border: '1px solid var(--color-rule)', background: 'var(--color-paper-50)' }}
                    >
                        {BANK.map(([k, v], i) => (
                            <div
                                key={k}
                                className="grid grid-cols-1 sm:grid-cols-3 gap-1 px-5 py-3"
                                style={{ borderTop: i === 0 ? 'none' : '1px solid var(--color-rule)' }}
                            >
                                <div
                                    className="text-[12px] uppercase font-semibold"
                                    style={{ letterSpacing: '0.08em', color: 'var(--color-gold-700)' }}
                                >
                                    {k}
                                </div>
                                <div className="sm:col-span-2 text-[14px]" style={{ color: 'var(--color-ink-700)' }}>
                                    {v}
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="mt-4 text-[14px]" style={{ color: 'var(--color-ink-500)', lineHeight: 1.7 }}>
                        Payment can also be made via Demand Draft / Cheque drawn in favour of{' '}
                        <strong>“Centre for Study of Politics and Governance”</strong>, payable at Delhi.
                    </p>

                    <div
                        className="mt-6 px-5 py-4"
                        style={{
                            background: 'var(--color-paper-100)',
                            borderLeft: '3px solid var(--color-gold-500)',
                            borderRadius: '2px'
                        }}
                    >
                        <div
                            className="text-[10.5px] uppercase font-semibold mb-1"
                            style={{ letterSpacing: '0.18em', color: 'var(--color-gold-700)' }}
                        >
                            Important Note
                        </div>
                        <p className="text-[14px]" style={{ color: 'var(--color-ink-600)', lineHeight: 1.7 }}>
                            Please email the UTR number / transaction details after completing the bank transfer so that
                            we can track your payment. For subscription and advertisement queries, write to{' '}
                            <a href="mailto:indianstudiesreview@gmail.com" style={{ color: 'var(--color-gold-700)' }}>
                                indianstudiesreview@gmail.com
                            </a>
                            .
                        </p>
                    </div>

                    <h2 className="font-display mt-12" style={{ fontSize: '1.6rem', color: 'var(--color-ink-700)' }}>
                        Subscriber Details
                    </h2>
                    <p className="mt-1 text-[13px]" style={{ color: 'var(--color-ink-400)' }}>
                        The official form (downloadable above) asks for the following details. Complete it and mail it
                        along with your remittance details to the address below.
                    </p>
                    <div
                        className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-px"
                        style={{ background: 'var(--color-rule)', border: '1px solid var(--color-rule)' }}
                    >
                        {['Name', 'Postal address', 'Phone', 'Mobile', 'Email', 'Subscription type', 'Duration', 'Date']
                            .map((f) => (
                                <div
                                    key={f}
                                    className="px-5 py-3.5 flex items-center gap-3"
                                    style={{ background: 'var(--color-paper-50)' }}
                                >
                                    <span style={{ color: 'var(--color-gold-700)' }}>›</span>
                                    <span className="text-[14px]" style={{ color: 'var(--color-ink-700)' }}>{f}</span>
                                </div>
                            ))}
                    </div>

                    <h2 className="font-display mt-12" style={{ fontSize: '1.6rem', color: 'var(--color-ink-700)' }}>
                        Submission of Form
                    </h2>
                    <div className="wp-prose mt-3">
                        <p>
                            Please mail this completed form (or a photocopy) along with your remittance details to:
                        </p>
                        <p>
                            <strong>Centre for Study of Politics and Governance</strong>
                            <br />
                            Room No. 220, Department of Political Science,
                            <br />
                            Faculty of Social Science, University of Delhi – 110007, India
                            <br />
                            <strong>Phone:</strong> 9555122120
                            <br />
                            <strong>Email:</strong> indianstudiesreview@gmail.com | cspgindia@gmail.com
                            <br />
                            <strong>Website:</strong> www.cspg.in
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}
